module.exports = __webpack_public_path__ + "static/media/dashboards.907c2ecc.png";